export default __webpack_public_path__ + "static/media/store.inline.215be6dd.svg";